// todo: move this where necessary
export interface ModelStateError {
  readonly ModelState: {
    [key: string]: string[];
  };
}

export function isModelStateError(error: any): error is ModelStateError {
  return error && 'ModelState' in error;
}
